module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    attrs: {
      "id": "donations-page"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "donations-list"
  }, [_c('div', {
    staticClass: "classifieds-type-selector"
  }, [_c('label', {
    staticClass: "switch"
  }, [_c('button', {
    class: [{
      active: _vm.sortType === 'amount'
    }],
    on: {
      "click": function($event) {
        _vm.setSortType('amount')
      }
    }
  }, [_vm._v("Amount")]), _vm._v(" "), _c('button', {
    class: [{
      active: _vm.sortType === 'date'
    }],
    on: {
      "click": function($event) {
        _vm.setSortType('date')
      }
    }
  }, [_vm._v("Date")])])]), _vm._v(" "), _vm._l((_vm.donors), function(donor) {
    return _c('div', {
      key: donor.id,
      staticClass: "donor"
    }, [_c('div', {
      staticClass: "avatar-container"
    }, [_c('avatar', {
      attrs: {
        "profile-data": donor,
        "profile-type": "developer",
        "size": "large",
        "show-xp-info": false
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "donation-details"
    }, [_c('span', {
      staticClass: "poster-alias"
    }, [_c('router-link', {
      attrs: {
        "to": ("/Developer/" + (donor.stringUrl))
      }
    }, [_vm._v(_vm._s(donor.alias))])], 1), _vm._v(" "), _c('span', {
      staticClass: "donation-amount"
    }, [_vm._v("$" + _vm._s(donor.amount))]), _vm._v(" "), _c('span', {
      staticClass: "donation-date"
    }, [_vm._v(_vm._s(_vm._f("formatDateWithoutTime")(donor.date)))])])])
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "donation-pitch"
  }, [_c('h1', [_vm._v("Thank you for considering a donation to Develteam!")]), _vm._v(" "), _c('p', [_vm._v("Develteam is a labor of love, with no on-site ads or subscription fees. Your donation helps keep\n            pay for operation costs, and encourages the continued development of features and fixes.")]), _vm._v(" "), _c('p', [_vm._v("Users who donate will also receive a special badge next to their name in chat and on their profile.")]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "https://www.paypal.com/cgi-bin/webscr",
      "method": "post",
      "target": "_blank"
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "cmd",
      "value": "_s-xclick"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "hosted_button_id",
      "value": "HHA7JMWKQ834E"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button",
    attrs: {
      "type": "submit",
      "value": "Donate on Paypal",
      "title": "PayPal - The safer, easier way to pay online!"
    }
  }, [_c('i', {
    staticClass: "fab fa-paypal"
  }), _vm._v(" Donate on Paypal\n            ")])]), _vm._v(" "), _c('p', {
    staticClass: "disclaimer"
  }, [_vm._v("Donations are manually entered into the database, so if you don't see your name right\n            away, please be patient. If you wish to remain anonymous, leave a note on the Paypal form.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3996c9c5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Pages/Donations/DonationsPage.vue
// module id = 853
// module chunks = 2